module.exports = __webpack_public_path__ + "static/img/HUSSIEN-EL-ACHKAR.278b0f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/HUSSIEN-EL-ACHKAR.jpg
// module id = So9f
// module chunks = 0